import { HTMLProps, PropsWithChildren } from "react";
import { StyledBorderedCard } from "./BordererCard.styles";
import { CSSObject } from "styled-components";

export interface BordererCardProps
    extends Pick<
            CSSObject,
            | "width"
            | "borderRadius"
            | "backgroundColor"
            | "borderColor"
            | "overflow"
        >,
        Pick<HTMLProps<HTMLDivElement>, "onClick" | "className"> {
    padded?: boolean;
}

const BordererCard = ({
    children,
    ...restProp
}: PropsWithChildren<BordererCardProps>) => {
    return <StyledBorderedCard {...restProp}>{children}</StyledBorderedCard>;
};

export default BordererCard;
